import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Poll the per-user unread-changelog count. Mirrors the cadence the
 * notifications bell uses so users see new "what's new" posts land
 * in roughly the same beat as other inbox-style signals.
 */
const POLL_MS = 60_000;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export function useUnreadChangelog() {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API_URL}/api/changelog/unread-count`, { headers: authHeaders() });
      setCount(Number(r.data?.unreadCount || 0));
    } catch {
      // Silent — header badge is non-critical; bad network shouldn't
      // throw a toast at the user every minute.
    }
  }, []);

  useEffect(() => {
    refresh();
    const onVis = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onVis);
    const id = window.setInterval(() => {
      if (document.visibilityState === 'visible') refresh();
    }, POLL_MS);
    return () => {
      document.removeEventListener('visibilitychange', onVis);
      window.clearInterval(id);
    };
  }, [refresh]);

  return { count, refresh };
}
